
//window._ = require('lodash');



/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    //window.$ = window.jQuery = require('jquery');

    //require('jquery-ui/ui/effects/effect-slide.js');
    //require('jquery-ui/ui/widgets/datepicker.js');
    //require('jquery-ui/ui/i18n/datepicker-hr.js');

    //window.bootstrap = require('bootstrap');




    


    //require('waypoints/lib/noframework.waypoints.js');


    //require('magnific-popup');

    //require('waypoints/lib/jquery.waypoints.min.js');


    window.Swal = require('sweetalert2');
    
    //require('jcarousel');

    //require('bootstrap-star-rating');

    //require('owl.carousel'); 

    
 

} catch (e) {}

require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/dropdown');
window.Modal = require('bootstrap/js/dist/modal');
require('./newsletter.js');
require('./feedback.js');
require('./review.js');
require('./http.js');
//require('./cookies.js');

require('@popperjs/core');

window.Tooltip = require('bootstrap/js/dist/tooltip');

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    this.addEventListener('hide.bs.tooltip', function () {
        new Tooltip(tooltipTriggerEl)
    })
    return new Tooltip(tooltipTriggerEl)
});

window.Popover = require('bootstrap/js/dist/popover');
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new Popover(popoverTriggerEl)
})
